import React, { useRef, useEffect, useState } from "react";
import renter from "../../assets/assets/images/car_detail/rentor_profile.png";
import messageicon from "../../assets/assets/images/car_detail/rentor_message.png";
import callicon from "../../assets/assets/images/car_detail/rentor_call.png";
import { FcLikePlaceholder } from "react-icons/fc";
import { HiColorSwatch } from "react-icons/hi";
import { BsFillFuelPumpFill } from "react-icons/bs";
import { FaMusic } from "react-icons/fa";
import { MdDoubleArrow } from "react-icons/md";
// import { Rating } from 'react-simple-star-rating'
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { TiSocialFacebook } from "react-icons/ti";
import { FaXTwitter } from "react-icons/fa6";
import { IoMdLink } from "react-icons/io";
import SliderImg from "../fields/SliderImg";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { IoPerson } from "react-icons/io5";
import { LuAirVent } from "react-icons/lu";
import { GrManual } from "react-icons/gr";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedCar } from "../../redux/Slice/carSlice";
import {
  cleanBookingData,
  cleanBookingDataWithFilter,
  clearBookCarData,
  setCarId,
  setCarRent,
} from "../../redux/Slice/bookingSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import Rating from "@mui/material/Rating";
import { toast } from "react-toastify";

const CarDetails = () => {
  const { carId } = useParams(); // Destructure carId from useParams
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getCartData = useSelector((state) => state?.car?.getCartData);
  const isFiltered = useSelector((state) => state?.car?.getCartData);
  const loginDetail = useSelector((state) => state?.auth?.loginId);
  const imageKeys = [
    "frontImage",
    "rightImage",
    "backImage",
    "leftImage",
    "numberPlateImage",
  ];
  const [sliderImages, setSliderImages] = useState([]);
  const [isBtnDisable, setIsBtnDisable] = useState(false);

  function findItemById(array, id) {
    return array.find((item) => item?._id === id);
  }
  // Check if getCartData is not null/undefined before using it
  const pageData = getCartData && findItemById(getCartData?.data, carId);
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  const handleSelectedCar = () => {
    if (loginDetail) {
      if (isBtnDisable) {
        toast("Insurance Expired");
      } else {
        dispatch(clearBookCarData());
        if (!isFiltered) dispatch(cleanBookingData());
        else dispatch(cleanBookingDataWithFilter());

        dispatch(setCarId(carId));
        dispatch(
          setCarRent({
            driverRent: pageData?.driver?.rent ? pageData?.driver?.rent : 0,
            carRent: pageData?.pricePerDay,
          })
        );
        navigate("/carbooking");
      }
    } else {
      navigate("/login", {
        state: {
          redirectBack: location?.pathname,
        },
        replace: true,
      });
      scrollToTop();
    }
  };
  // const detailImage = useRef()

  // var settings = {
  //     dots: false,
  //     infinite: false,
  //     speed: 500,
  //     slidesToShow: 3,
  //     slidesToScroll: 1,
  //     fade: false,
  //     arrow: true
  // };

  // const getImage = (index) => {
  // }

  useEffect(() => {
    const imagesArray = Object.entries(pageData)
      .filter(
        ([key, value]) => imageKeys.includes(key) && typeof value === "string"
      )
      .map(([key, value]) => value);
    setSliderImages(imagesArray);

    const givenDate = dayjs(pageData?.insurance?.expiryDate);

    // Get the current date
    const currentDate = dayjs();

    // Calculate the difference in days between the given date and the current date
    const differenceInDays = givenDate.diff(currentDate, "day");

    if (differenceInDays > 0) {
      setIsBtnDisable(false);
    } else {
      setIsBtnDisable(true);
    }
  }, [pageData]);

  // Convert the string to a dayjs object

  return (
    <div className="container-xxl mt-4 pb-6">
      <div className="row m-0 p-0">
        <div className="col-md-6">
          <h1 className="font secondaryColor mb-3 d-flex align-items-center car-detail-name text-capitalize">
            <span className="lh-0">
              <MdDoubleArrow />
            </span>
            {pageData?.maker?.carMake} {pageData?.carCategoryId?.categoryName}
          </h1>
          <div>
            <SliderImg sliderImages={sliderImages} />
          </div>
        </div>
        <div className="col-md-6 p-2 pt-3 pt-md-0 p-md-5">
          <div className="d-flex flex-row align-items-center justify-content-between">
            {/* <p className=' font secondaryColor fs3' >K220/day</p> */}
            <p className=" font secondaryColor fs3">
              K{pageData?.pricePerDay}/Day
            </p>
            <div className="d-flex mb-3">
              {/* <div data-tooltip-id="heart" >
                                <FcLikePlaceholder className='fs-1 mx-2 pointor' />
                            </div> */}
              {/* {isBtnDisable ?
                                <span className=" "
                                >Insurence expired</span>
                                :
                                <button type="button" className=" mx-2 booking-btn-desktop px-5 btn img-btn primaryColor" onClick={handleSelectedCar}

                                >Rent now</button>
                            } */}

              {pageData?.userId === loginDetail ? null : (
                <button
                  type="button"
                  className=" mx-2 booking-btn-desktop px-5 btn img-btn primaryColor"
                  onClick={handleSelectedCar}
                >
                  Rent now
                </button>
              )}
              <ReactTooltip id="heart" place="bottom" content="Favourite" />
            </div>
          </div>
          <Rating
            name="avg Rating"
            value={+pageData?.averageRating} // Assuming pageData contains the average rating
            precision={0.5} // Set precision to 0.5 to allow half-star values
            readOnly
            size="large" // Set the size of the stars
          />
          {/* driver section */}

          {/* <div className='d-flex flex-row gap-4 align-items-center my-3' >
                        <img src={renter} className='img-renter' />
                        <p>Cameron Williamson</p>
                        <img className='renter-icon pointor' src={messageicon} />
                        <img className='renter-icon pointor' src={callicon} />
                    </div> */}
          <div className="my-3">
            <h3 className="font mb-2">Specifications</h3>
            <div className="d-flex flex-row flex-wrap gap-3">
              <div className="radio-shadow rounded-3 p-2">
                <p className="text-secondary fs14">Max Power</p>
                {/* <p className='fs14' >320 HP</p> */}
                <p className="fs14">{pageData?.power}</p>
              </div>
              <div className="radio-shadow rounded-3 p-2">
                <p className="text-secondary fs14">Top speed</p>
                {/* <p className='fs14' >220 km/h</p> */}
                <p className="fs14">{pageData?.topSpeed} km/h</p>
              </div>
              <div className="radio-shadow rounded-3 p-2">
                <p className="text-secondary fs14">Motor</p>
                <p className="fs14">{pageData?.motor}cc</p>
              </div>
            </div>
          </div>
          <div className="my-3">
            <h3 className="font mb-2">Features</h3>

            {/* <div className='d-flex flex-row  mt-2 flex-wrap gap-5' >
                            <div className='d-flex flex-column gap-1' >
                                <p className='fs24'><IoPerson className='feature-icon' />{pageData?.numberOfSeats} Seater</p>
                                <p className='fs24'><LuAirVent className='feature-icon' />Air Conditioning</p>
                                <p className='fs24'><FaMusic className='feature-icon' />Music</p>
                            </div>
                            <div className='d-flex flex-column gap-1' >
                                <p className='fs24'><HiColorSwatch className="feature-icon" />Color</p>
                                <p className='fs24'><BsFillFuelPumpFill className='feature-icon' />Full tank</p>
                                <p className='fs24'><GrManual className='feature-icon' />Manual</p>
                            </div>
                        </div> */}
            <div className="d-flex flex-row  mt-2 flex-wrap gap-md-4 gap-3  col-12 ">
              {pageData?.features?.map((ele) => (
                // ele?.icon
                <div className="d-flex flex-column " key={ele?._id}>
                  <p className="fs24 ">
                    {" "}
                    <i className={`${ele?.icon} feature-icon`}></i>
                    {ele?.carFeature}{" "}
                  </p>
                </div>
              ))}
            </div>
          </div>
          {/* <div className='my-3' >
                        <h3 className='font mb-2' >Description</h3>
                        <p className='text-secondary fs14' >Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in</p>
                    </div> */}
          <div className="my-3">
            <h3 className="font mb-2">Share</h3>
            <div className="d-flex flex-row align-items-center">
              <div className="facebook-bg pointor">
                <p>
                  <TiSocialFacebook className="share-icon " />
                </p>
              </div>
              <div className="twitter-bg pointor">
                <p>
                  <FaXTwitter className="share-icon" />
                </p>
              </div>
              <div className="link-bg pointor">
                <p>
                  <IoMdLink className="share-icon" />
                </p>
              </div>
            </div>
          </div>

          <button
            type="button"
            onClick={handleSelectedCar}
            className=" w-100 booking-btn-mobile px-5 btn img-btn primaryColor"
          >
            Rent now
          </button>
        </div>
      </div>
    </div>
  );
};

export default CarDetails;
